import { create } from "zustand";

type DialogState = {
  open: boolean;
  setOpen: (value: boolean) => void;
  openDialog: () => void;
  closeDialog: () => void;
};

type UseAuthDialogStore = {
  signIn: DialogState;
  signUp: DialogState;
  forgotPassword: DialogState;
};

export const useAuthDialogStore = create<UseAuthDialogStore>((set) => ({
  signIn: {
    open: false,
    setOpen: (value) => set((state) => ({ signIn: { ...state.signIn, open: value } })),
    openDialog: () => set((state) => ({ signIn: { ...state.signIn, open: true } })),
    closeDialog: () => set((state) => ({ signIn: { ...state.signIn, open: false } })),
  },
  signUp: {
    open: false,
    setOpen: (value) => set((state) => ({ signUp: { ...state.signUp, open: value } })),
    openDialog: () => set((state) => ({ signUp: { ...state.signUp, open: true } })),
    closeDialog: () => set((state) => ({ signUp: { ...state.signUp, open: false } })),
  },
  forgotPassword: {
    open: false,
    setOpen: (value) => set((state) => ({ forgotPassword: { ...state.forgotPassword, open: value } })),
    openDialog: () => set((state) => ({ forgotPassword: { ...state.forgotPassword, open: true } })),
    closeDialog: () => set((state) => ({ forgotPassword: { ...state.forgotPassword, open: false } })),
  },
}));


// type SigAuthDialogStore = {
//   open: boolean;
//   openDialog: () => void;
//   closeDialog: () => void;
//   setOpen: (value: boolean) => void;
//   openSignUp: boolean;
//   openSignUpDialog: () => void;
//   closeSignUpDialog: () => void;
//   setOpenSignUp: (value: boolean) => void;

//   openForgotPassword: boolean;
//   openForgotPasswordDialog: () => void;
//   closeForgotPasswordDialog: () => void;
//   setOpenForgotPassword: (value: boolean) => void;
// };

// export const useAuthDialogStore = create<SigAuthDialogStore>((set) => ({
//   open: false,
//   openDialog: () => set({ open: true }),
//   closeDialog: () => set({ open: false }),
//   setOpen: (value) => set({ open: value }),
//   openSignUp: false,
//   openSignUpDialog: () => set({ openSignUp: true }),
//   closeSignUpDialog: () => set({ openSignUp: false }),
//   setOpenSignUp: (value) => set({ openSignUp: value }),

//   openForgotPassword: false,
//   openForgotPasswordDialog: () => set({ open: true }),
//   closeForgotPasswordDialog: () => set({ open: true }),
//   setOpenForgotPassword: (value) => set({ open: value }),
// }));
